import { render, staticRenderFns } from "./TestbankHistoryQuestionSubjective.vue?vue&type=template&id=bcc2cfe0&"
import script from "./TestbankHistoryQuestionSubjective.vue?vue&type=script&lang=js&"
export * from "./TestbankHistoryQuestionSubjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc2cfe0')) {
      api.createRecord('bcc2cfe0', component.options)
    } else {
      api.reload('bcc2cfe0', component.options)
    }
    module.hot.accept("./TestbankHistoryQuestionSubjective.vue?vue&type=template&id=bcc2cfe0&", function () {
      api.rerender('bcc2cfe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/TestbankHistoryQuestionSubjective.vue"
export default component.exports